module.exports = __webpack_public_path__ + "img/bg_function06_3_t.1ed33df2.svg";